export class UsbDevice {
  path: string;
  serial: string;

  constructor(path: string, serial: string) {
    this.path = path;
    this.serial = serial;
  }
}
